
export const WAITING_AUTHORIZATION = 'Waiting Authorization';
export const BACKGROUND_COMPLETED = 'Background Completed';
